import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import PreLoader from "./components/PreLoader";
import Home from "./page/home/Home";
import Blog from "./page/blog/Blog";
import BlogDetail from "./page/blog/BlogDetail";
import ScrollManager from "./components/ScrollManager";
import "./App.css";
import Contact from "./page/contact/Contact";
import ComingSoon from "./page/ComingSoon";
import Cases from "./page/cases/Cases";
import CaseDetail from "./page/cases/CaseDetail";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <>
            <PreLoader />
            <ScrollManager />
            <Header />
            <main className="bg-white dark:bg-gray-900 transition-colors duration-200">
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <Home />
                    </>
                  }
                />
                <Route
                  path="/about"
                  element={<ComingSoon />}
                />
                <Route path="/blog" element={<Blog />} />
                <Route
                  path="/blog/:title"
                  element={<BlogDetail />}
                />
                <Route path="/cases" element={<Cases />} />
                <Route
                  path="/cases/:name"
                  element={<CaseDetail />}
                />
                <Route
                  path="/contact"
                  element={<Contact />}
                />
                <Route
                  path="/career"
                  element={<ComingSoon />}
                />
                <Route
                  path="/career-single"
                  element={<ComingSoon />}
                />
                <Route
                  path="/cooperation"
                  element={<ComingSoon />}
                />
                <Route
                  path="/cooperation-single"
                  element={<ComingSoon />}
                />
                <Route
                  path="/pricing"
                  element={<ComingSoon />}
                />
                <Route
                  path="/terms-conditions"
                  element={<ComingSoon />}
                />
                <Route path="*" element={<ComingSoon />} />
              </Routes>
            </main>
            <Footer />
            <ScrollToTopButton />
          </>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
